import { useCallback } from 'react'

const dtmfFrequencies = {
  '1': [697, 1209],
  '2': [697, 1336],
  '3': [697, 1477],
  '4': [770, 1209],
  '5': [770, 1336],
  '6': [770, 1477],
  '7': [852, 1209],
  '8': [852, 1336],
  '9': [852, 1477],
  '*': [941, 1209],
  '0': [941, 1336],
  '#': [941, 1477],
} as const

const audioContext = new AudioContext()

const gainNode = audioContext.createGain()
gainNode.gain.value = 0.01
gainNode.connect(audioContext.destination)

const initOscillator = () => {
  const oscillator = audioContext.createOscillator()
  oscillator.type = 'sine'
  oscillator.connect(gainNode)
  return oscillator
}

type DTMFKey = keyof typeof dtmfFrequencies

export const usePlayDTMF = () => {
  const playDTMF = useCallback((dtmf: DTMFKey | string) => {
    if (dtmf in dtmfFrequencies) {
      dtmfFrequencies[dtmf as DTMFKey].map((frequency: number) => {
        const oscillator = initOscillator()
        oscillator.frequency.value = frequency
        oscillator.start()
        setTimeout(() => {
          oscillator.stop()
        }, 200)
        return oscillator
      })
    }
  }, [])

  return playDTMF
}
